export default __webpack_public_path__ + "static/media/Happy Windows II.8f36d6bb.jpg";